import React from 'react';
import PropTypes from 'prop-types';

import { USER_TYPES } from 'dpl/shared/constants/shared';
import SignupFormContainer from 'dpl/containers/SignupFormContainer';

export default function UserAuthBreederSignupForm({ match }) {
  return (
    <div className="UserAuthBreederSignupForm">
      <h1 className="mb10 f6">Join as Breeder</h1>

      <p className="mb10">
        Join our community of great breeders and get access to free tools to
        track your litters, families, and more.
      </p>

      <SignupFormContainer
        buttonClassName="button button--primary ph7 pv2 center"
        buttonText="Sign up"
        userType={USER_TYPES.BREEDER}
        referredBy={match.params.referredBy}
      />
    </div>
  );
}

UserAuthBreederSignupForm.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      referredBy: PropTypes.string
    }).isRequired
  }).isRequired
};
